import { requestsByIds } from "../services/copilot";
import { mapRequestToRequestResponseViewModel } from "../helpers/copilotMessageMapper";

export const useRequestsByIds = () => {
  const onExecute = async (ids: string[]) => {
    if (!ids) return;

    const requests = await requestsByIds(ids);
    return mapRequestToRequestResponseViewModel(requests, true);
  };

  return {
    getRequestsByIds: onExecute,
  };
};
